<template>
  <div class="file-import">
    <!-- 上传，限制张数 -->
    <Upload ref="file-import"
            multiple
            :default-file-list="defaultList"
            :on-success="handleSuccess"
            :on-remove="handleRemove"
            :format="format"
            :max-size="102400"
            :on-format-error="handleFormatError"
            :on-exceeded-size="handleMaxSize"
            :before-upload="handleBeforeUpload"
            name="imgFile"
            :data="postData"
            :headers="headData"
            action="/common/upload/file">
      <Button icon="ios-cloud-upload-outline">选择文件</Button>
    </Upload>
    <Alert>上传文件格式为MP3或者MP4，大小不超过50M，请自己处理好宽高比例</Alert>

    <!-- <Alert type="warning"
           class="mt10">{{ alterString }}</Alert> -->
  </div>
</template>
  
  <script>
export default {
  name: "FileImport",
  data () {
    return {
      // 已经上传成功的所有文件结果
      videoList: [],
      resList: [],
      headData: {
        Authorization: this.$store.getters.token
      },
      postData: {
        thumb: 0,
        thumbWidth: "200px",
        thumbWidth: "200px"
      }
    };
  },
  props: {
    alterString: {
      type: String,
      default: function () {
        return "请严格按照模板填写内容，上传！";
      }
    },
    defaultList: {
      type: Array,
      default: function () {
        return [];
      }
    },
    format: {
      type: Array,
      default: function () {
        return ["mp4", "mp3", "doc", "docx", "xls", "xlsx", "pdf", "pem",];
      }
    }
  },
  mounted () {
    this.resList = this.$refs["file-import"].fileList;
  },
  watch: {
    defaultList (curVal, oldVal) {
      if (curVal) {
        this.resList = curVal;
      }
    }
  },
  created: function () { },
  methods: {
    handleClearFiles () {
      // 再次点击上传之前，清空之前已上传文件
      this.$refs["file-import"].clearFiles();
    },
    // 移除的回调
    handleRemove (file) {
      this.resList = this.$refs["file-import"].fileList;
    },
    // 上传成功的回调
    handleSuccess (res, file) {
      // console.log(res)
      if (res.code == 200) {
        this.$Notice.success({
          title: "导入成功",
          desc: "导入成功，请检查信息是否完整！"
        });
        // 更新显示的

        this.resList = this.$refs["file-import"].fileList;
      } else {
        this.$Notice.warning({
          title: "上传失败",
          desc: res.msg
        });
      }
    },
    // 检查文件格式
    handleFormatError (file) {
      this.$Notice.warning({
        title: "文件格式不正确",
        desc:
          "文件 " + file.name + " 格式不正确, 请插入doc,docx,xls,xlsx,pdf,mp3。"
      });
    },
    // 检查大小
    handleMaxSize (file) {
      this.$Notice.warning({
        title: "文件大小超出限制",
        desc: "文件 " + file.name + " 太大，最大就不要超过100M！"
      });
    },
    // 上传前检查数量
    handleBeforeUpload () {
      const check = this.resList.length < 10;
      if (!check) {
        this.$Notice.warning({
          title: "已经超出最大可上传数量！"
        });
      }
      return check;
    }
  }
};
  </script>
  
  